angular.module('unergie.main')
.factory('OverdueProcessUtilsService', () => {
    const getOverdueStatusMapping = (status) => {
        const result = { simpleStatus: status, step: 'TBD', color: 'black' }
        if (status.startsWith('CANCELLED_')) {
            result.simpleStatus = 'Annulé'
            result.color = 'black'
        } else if (status.startsWith('FINISHED_')) {
            result.simpleStatus = 'Terminé'
            if (status.startsWith('FINISHED_DELETED_MANUALLY_AT_')) {
                result.simpleStatus += ' (supprimé manuellement)'
            }
            result.color = 'dark-green'
        } else {
            result.simpleStatus = 'En cours'
            result.color = 'orange'
        }

        const steps = {
            INITIAL: 'Démarrage',
            R1_SENT: 'Relance 1 envoyée',
            SMS1BIS_SENT: 'Relance 1 BIS envoyée',
            SMS1TER_SENT: 'Relance 1 TER envoyée',
            R2_SENT: 'Relance 2 envoyée',
            ENERGY_CHECK_CHECKED: 'Relance 2 envoyée',
            R3_SENT: 'Relance 3 envoyée',
            LRAR_WS_SENT: 'Recommandé envoyée',
            STARTED_REDUC_OUTAGE_PROCESS: 'A limiter/couper',
            SUSPENSION_REQUESTED: 'Coupure demandée',
            LIMITATION_REQUESTED: 'Limitation demandée',
            RAN2_SENT: 'Relance AN2 envoyée (limité/coupé)',
            R4_SENT: 'Relance 4 envoyée (limité/coupé)',
            SMS5_SENT: 'Relance 5 envoyée (à rétablir)',
            ON_HOLD: 'En attente',
            RA1_SENT: 'Relance 1 envoyée (post résil)',
            RA2_SENT: 'Relance 2 envoyée (post résil)',
            RMD_SENT: 'Recommandé envoyée (post résil)',
        }

        _.each(steps, (value, key) => {
            if (status.includes(key)) {
                result.step = value
                return false
            }
        })

        return result
    }

    return {
        getOverdueStatusMapping,
    }
})
